import { RecordType } from '@modules/planning/children/scheme-editor/types';

export const searchAndFilterKeysInSchemeTransfer = (inputValue: string, option: RecordType) =>
  option.description.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
  option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
  option.key.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
  inputValue === '' ||
  !inputValue;
